import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ui-mandatory-message',
  standalone: true,
  imports: [CommonModule],
  styleUrl: './ui-mandatory-message.component.scss',
  template: `<div class="form-field__mandatory-message" i18n="@@form.field.mandatoryMessage">
    <span class="form-field__mandatory"></span>Marked fields are mandatory
  </div>`
})
export class UiMandatoryMessageComponent {}
